import HttpStatusError from "./http-status-error";
export const sendTextGetRequestToServer = async url => {
  return await fetch(url).then(res => {
    if (res.ok) {
      return res.text();
    }
    return new HttpStatusError(res.status);
  });
};

export const sendJsonGetRequestToServer = async url => {
  return await fetch(url).then(res => {
    if (res.ok) {
      return res.json();
    }
    return new HttpStatusError(res.status);
  });
};
